import { INTEGRATION_TYPES } from '@model';
import { SectionRadioLabel } from '@model/settings/addModalConfig';

// NOTE: please do not use this file, all configs for adding module were moved to src/model/settings/addModalConfig.js

export const addModuleConfig = {
  addTitle: 'Add New Module',
  addNew: 'Module Type',
  isModule: true,
  radios: [
    {
      value: 'powerbiModule',
      text: SectionRadioLabel.PBI,
      typeText: 'Power BI',
      // tipTitle:
      //   'Create a module on the left pane to quickly navigate to an iFramed Power BI dashboard',
    },
    {
      value: 'imageModule',
      text: SectionRadioLabel.Image,
      typeText: 'Image',
    },
    {
      value: 'regular',
      text: SectionRadioLabel.Other,
      typeText: 'Other',
    },
    {
      value: 'widget',
      text: 'Visualization Widget (Spider Chart)',
      typeText: 'Visualization Widget',
    },
    {
      value: INTEGRATION_TYPES.TEXT_CONTAINER,
      text: SectionRadioLabel.Richtext,
      typeText: 'Text',
    },
    {
      value: INTEGRATION_TYPES.MULTI_SECTION,
      text: 'Multi-section',
      typeText: 'Multi-section',
    },
  ],
  typeTextMap: [
    {
      value: 'powerbiModule',
      typeText: 'Power BI',
    },
    {
      value: 'imageModule',
      typeText: 'Image',
    },
    {
      value: 'regular',
      typeText: 'Other',
    },
    // {
    //   value: 'widget',
    //   typeText: 'Visualization Widget',
    // },
    {
      value: INTEGRATION_TYPES.TEXT_CONTAINER,
      typeText: 'Text',
    },
    {
      value: INTEGRATION_TYPES.MULTI_SECTION,
      typeText: 'Multi-section',
    },
    {
      value: 'default',
      typeText: 'Default',
    },
  ],
  // ratioNeedFullSize: true,
};
